import barba from '@barba/core';
import anime from "animejs"
const duration = 300

import logger from './logger.js';
import { showScrollToEnter, showSquare } from "./cursorhelper";
barba.init({
    name: 'default-transition',
    timeout: 15000,

    transitions: [{
        async leave(data) {


            await anime({
                targets: data.current.container,
                opacity: 0,
                duration: duration,
                easing: 'easeOutQuad',
            }).finished;
        },

        async beforeEnter(data){
            logger('barba.js #23 \n>before enter\n',window.loggerColor)

            try {
                const template = data.next.container.dataset.template;
                if(template){
                    window.dispatchEvent(new CustomEvent('next-page-template', { detail: template.toUpperCase() }));
                }
            } catch (e){
                console.warn(e)
            }
            await anime({
                targets: data.next.container,
                opacity: 0,
                duration: 0,
                easing: 'easeOutQuad',
                complete: function (anim) {
                    data.current.container.remove()

                    // Fire off an event listened to by the alpine component.
                    let title= "";
                    if(data.next.container.dataset.title){
                        title = data.next.container.dataset.title
                    } else {
                        console.warn('missing page title')
                    }

                    window.dispatchEvent(new CustomEvent('on-page-title-change',{detail:title}));
                }
            }).finished;
        },

        async enter(data) {


            showSquare()
            window.scrollTo(0, 0);
            document.body.classList.remove('is-on-homepage-top-section')



            // if (window.location.href.indexOf("studio") != -1){
            if(data.next.url.path=="/studio"){
                window.dispatchEvent( new CustomEvent('hide-page-title-transformer'))
            } else {
                window.dispatchEvent( new CustomEvent('show-page-title-transformer'))
            }

            // const slider = data.next.container.querySelector('.swiper');

            // Scroll to enter text
            // TODO: Should be global function.
            // const cursors = document.querySelectorAll('.cursor');
            // if(cursors){
            //     cursors.forEach(cursor => {
            //         cursor.classList.remove('scrollEnter')
            //     });
            // }

            // if(slider){
            //     Slider('.swiper')
            // }
            return await anime({
                targets: data.next.container,
                opacity: 1,
                duration: duration,
                easing: 'easeInQuad',
            }).finished;
        }
    }]
});
